export default {
	NotificationUser: {},
	IsShowNotification: false,
	NotificationInvoiceWaiting: {},
	NotificationsInbot: [],
	NotificationProcessSyncData: [],
	IsShowNotificationChangeStatusInvoice: false,
	IsShowNewFeature: false,
	AssistantPanelData: []
};
